import { initializeDataDictionaryModal } from "./data-dictionary-modal"

export async function UpdateDataDictionaryMobileCard(tableData) {
    const wrapper = document.getElementById("dataDictionaryCardsWrapper")

    if (!wrapper || !tableData.dataElements || tableData.dataElements.length === 0) {
        return
    }

    wrapper.innerHTML = tableData.dataElements.map((element) => createCard(element)).join("")

    initializeDataDictionaryModal()
}

function escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
}

function createCard(element) {
    const hasDataType = element.dataType?.name
    const smallDescreiption =
        element.description.length > 88
            ? element.description.substring(0, 88) + "..."
            : element.description

    return `
        <div class="bg-[#D9E2E5] rounded-[28px] border-[#D9E2E5] p-6 font-roboto" id="${escapeHtml(
            element.id
        )}">
            <h3 class="mb-9" data-name="${escapeHtml(element.name)}">
                ${escapeHtml(element.name)}
            </h3>
            ${
                element.description
                    ? `<p class="pb-6" data-description="${escapeHtml(element.description)}">
                        ${escapeHtml(smallDescreiption)}
                    </p>`
                    : ""
            }
            <div class="flex ${hasDataType ? "justify-between" : "justify-end"}">
                ${
                    hasDataType
                        ? `<button class="btn btn--tag cursor-pointer pointer-events-none bg-transparent max-w-[70%]" data-type="${escapeHtml(
                              element.dataType.name
                          )}">
                            ${escapeHtml(element.dataType.name)}
                        </button>`
                        : ""
                }
                <button class="text-link js-open-modal" data-element-id="${escapeHtml(element.id)}">
                    View details
                </button>
            </div>
        </div>
    `
}
